import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shell } from "./SiteParts";

export default function SiteCodeEntry() {
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const go = e => {
    e.preventDefault();
    if (!/^\d{6}$/.test(code)) { setErr("Enter the 6 digit code from the site sign."); return; }
    nav(`/qr/${code}`);
  };
  return (
    <Shell>
      <form className="card space-y-3" onSubmit={go} data-testid="site-code-form">
        <h1 className="text-2xl">Can't scan the code?</h1>
        <div className="text-sm opacity-70">Enter the 6 digit site code shown on the site sign.</div>
        <input className="input w-full text-center text-3xl tracking-[0.4em]" inputMode="numeric" maxLength={6}
          value={code} onChange={e => setCode(e.target.value.replace(/\D/g, ""))} placeholder="000000" data-testid="site-code-input"/>
        {err && <div className="text-red-400 text-sm" data-testid="site-code-error">{err}</div>}
        <button className="btn-silver w-full py-3" data-testid="site-code-submit">Go to site sign-in</button>
      </form>
    </Shell>
  );
}
